class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    const parent = this.notification.parentElement;
    parent.classList.add('active');
    setTimeout(function () {
      parent.classList.add('open');
    }, 250);

  }

  close() {
    const parent = this.notification.parentElement;
    parent.classList.remove('open');
    setTimeout(function () {
      parent.classList.add('active');
    }, 250);
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach(section => {
      var _sectionId = document.getElementById(section.id);
      _sectionId.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (section.id === 'cart-notification-product') {
        var _items = _sectionId.querySelectorAll('.cart-item');
        if (!_items.length) {
          _sectionId.classList.add('_empty');
        } else {
          _sectionId.classList.remove('_empty');
        }
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product'
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-icon-header'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  updateQuantity(line, quantity, sections) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        this.renderContents(parsedState);
      }).catch(() => {
      })
      .finally(() => {
        // for animation if .... necesary
      });
  }
}


function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

customElements.define('cart-notification', CartNotification);

class ItemRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      var line = this.dataset.index;
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var sections = cartNotification.getSectionsToRender().map((section) => section.id);
      cartNotification.updateQuantity(line, 0, sections);
    });
  }
}

customElements.define('item-remove-button', ItemRemoveButton);
